import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Box, Typography, Button } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import AdvisorDashboardTile from './AdvisorDashboardTile';
import QueuedPostContainer from 'app/containers/posts_queue/QueuedPostContainer';
import { useGetScheduledPostsQuery } from 'app/api/feedsApi';
import { useGetAppConfigQuery } from 'app/api/mainApi';

const AdvisorScheduledPosts = () => {
  const { data: appConfig } = useGetAppConfigQuery();

  // non-feeds advisors should not see this tile
  if (appConfig?.currentUser && !appConfig.currentUser.isFeedsAdvisor) return null;

  const { data: scheduledPosts } = useGetScheduledPostsQuery();
  const navigate = useNavigate();

  const content = (!scheduledPosts || (scheduledPosts.length === 0)) ? (
    <Stack direction="column" spacing={2} alignItems="center">
      <Typography variant="h5">No Scheduled Posts</Typography>
      <Typography variant="body1">
        Schedule posts to keep your subscribers engaged, even when you&apos;re away!
      </Typography>
      <Button
        onClick={() => navigate('/feed/create_post')}
        variant="contained"
        color="primary"
      >
        Schedule Post
      </Button>

    </Stack>
  ) : (
    <table className="table">
      <tbody className="start-xs compact" style={{ fontSize: '12px' }}>
        {scheduledPosts.slice(0, 2).map((post) => (
          <QueuedPostContainer
            key={post.id}
            post={post}
            displayScheduledDate
            showPostActionMenu={false}
            showMediaCounts={false}
          />
        ))}
      </tbody>
    </table>
  );

  return (
    <AdvisorDashboardTile
      title="Scheduled Posts"
      icon={<HelpOutlineIcon sx={{ color: '#888' }} />}
      manageLink="/feed/queue/scheduled"
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          my: 4,
        }}
      >
        {content}
      </Box>
    </AdvisorDashboardTile>
  );
};

export default AdvisorScheduledPosts;
